export const ACLStateConstants = {
  SET_ACL_STATE: "SET_ACL_STATE",
  UPDATE_ALL_ACL_PERMISSIONS: "UPDATE_ALL_ACL_PERMISSIONS",
  UPDATE_ALL_ACL_POLICIES: "UPDATE_ALL_ACL_POLICIES",
  UPDATE_ALL_ACL_PERM_CATEGORIES: "UPDATE_ALL_ACL_PERM_CATEGORIES",
  CLEAR_ACL_STATE: "CLEAR_ACL_STATE",
  UPDATE_ACL_PERMISSIONS: "UPDATE_ACL_PERMISSIONS",
  UPDATE_ACL_GROUPS: "UPDATE_ACL_GROUPS",
};